import { dayjs } from './apis'
import AutocallApiService from './apis/api'

const APIs = {
  dayjs,
  api: new AutocallApiService()
}

export { APIs }
